export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/sizechart.5ea582c7.svg","height":22,"width":31,"blurWidth":0,"blurHeight":0};